import React from "react";
import "./TextContent.css";
import { useTranslation } from "react-i18next";

const TextContent = () => {
  const { t } = useTranslation();

  return (
    <div className="about-container">
      <h2>{t("app.about.mainTitle")}</h2>

      <section className="intro">
        <h3>{t("app.about.intro.title")}</h3>
        <p
          dangerouslySetInnerHTML={{ __html: t("app.about.intro.content") }}
        ></p>
      </section>

      <section className="features">
        <h3>{t("app.about.features.title")}</h3>
        <ul>
          <li>
            <strong>{t("app.about.features.extractTextTitle")}</strong>
            {" – "}
            {t("app.about.features.extractText")}
          </li>
          <li>
            <strong>{t("app.about.features.editReviewTitle")}</strong>
            {" – "}
            {t("app.about.features.editReview")}
          </li>
          <li>
            <strong>{t("app.about.features.multiLanguageTitle")}</strong>
            {" – "}
            {t("app.about.features.multiLanguage")}
          </li>
          <li>
            <strong>{t("app.about.features.fastSecureTitle")}</strong>
            {" – "}
            {t("app.about.features.fastSecure")}
          </li>
          <li>
            <strong>{t("app.about.features.userFriendlyTitle")}</strong>
            {" – "}
            {t("app.about.features.userFriendly")}
          </li>
        </ul>
      </section>

      <section className="how-to-use">
        <h3>{t("app.about.howToUse.title")}</h3>
        <ol>
          <li>
            <strong>{t("app.about.howToUse.step1Title")}</strong>
            {" – "}
            {t("app.about.howToUse.step1")}
          </li>
          <li>
            <strong>{t("app.about.howToUse.step2Title")}</strong>
            {" – "}
            {t("app.about.howToUse.step2")}
          </li>
          <li>
            <strong>{t("app.about.howToUse.step3Title")}</strong>
            {" – "}
            {t("app.about.howToUse.step3")}
          </li>
          <li>
            <strong>{t("app.about.howToUse.step4Title")}</strong>
            {" – "}
            {t("app.about.howToUse.step4")}
          </li>
          <li>
            <strong>{t("app.about.howToUse.step5Title")}</strong>
            {" – "}
            {t("app.about.howToUse.step5")}
          </li>
        </ol>
      </section>

      <section className="why-choose">
        <h3>{t("app.about.whyChoose.title")}</h3>
        <ul>
          <li>
            <strong>{t("app.about.whyChoose.noSignupTitle")}</strong>
            {" – "}
            {t("app.about.whyChoose.noSignup")}
          </li>
          <li>
            <strong>{t("app.about.whyChoose.multipleFormatsTitle")}</strong>
            {" – "}
            {t("app.about.whyChoose.multipleFormats")}
          </li>
          <li>
            <strong>{t("app.about.whyChoose.aiPoweredTitle")}</strong>
            {" – "}
            {t("app.about.whyChoose.aiPowered")}
          </li>
          <li>
            <strong>{t("app.about.whyChoose.freeToUseTitle")}</strong>
            {" – "}
            {t("app.about.whyChoose.freeToUse")}
          </li>
        </ul>
      </section>

      <section className="use-cases">
        <h3>{t("app.about.useCases.title")}</h3>
        <ul>
          <li>
            <strong>{t("app.about.useCases.paperDocumentsTitle")}</strong>
            {" – "}
            {t("app.about.useCases.paperDocuments")}
          </li>
          <li>
            <strong>{t("app.about.useCases.screenshotsTitle")}</strong>
            {" – "}
            {t("app.about.useCases.screenshots")}
          </li>
          <li>
            <strong>{t("app.about.useCases.signboardsMenusTitle")}</strong>
            {" – "}
            {t("app.about.useCases.signboardsMenus")}
          </li>
          <li>
            <strong>{t("app.about.useCases.handwrittenNotesTitle")}</strong>
            {" – "}
            {t("app.about.useCases.handwrittenNotes")}
          </li>
        </ul>
      </section>

      <section className="cta">
        <h3>{t("app.about.cta.title")}</h3>
        <p dangerouslySetInnerHTML={{ __html: t("app.about.cta.content") }}></p>
      </section>
    </div>
  );
};

export default TextContent;
